import Main from './Main';

export default {
  main: Main,
};
